<template>
    <div>
        <div class="one mt-3">
            <div class="form-floating">
                <input  type="text" class="form-control" id="floatingInput" :placeholder="$t('company.kontaktnaosoba_text_1')"
                        v-model="meno">
                <label for="floatingInput">{{ $t('company.kontaktnaosoba_text_1') }}</label>
            </div>
        </div>
        <div class="one mt-3">
            <div class="form-floating">
                <input  type="text" class="form-control" id="floatingInput" :placeholder="$t('company.kontaktnaosoba_text_2')"
                        v-model="tel" @keypress="onlyNumber">
                <label for="floatingInput">{{ $t('company.kontaktnaosoba_text_2') }}</label>
            </div>
        </div>
        <div class="one mt-3">
            <div class="form-floating">
                <input  type="text" class="form-control" id="floatingInput" :placeholder="$t('company.kontaktnaosoba_text_3')"
                        v-model="email">
                <label for="floatingInput">{{ $t('company.kontaktnaosoba_text_3') }}</label>
                <div class="info">
                    <div class="my_tooltip">{{ $t('company.kontaktnaosoba_text_4') }}</div>
                    <div class="tooltip_hover info_icon">
                        <img src="/img/info_icon.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: ['company'],
    data() {
        return {
            meno: "",
            email: "",
            tel: ""
        }
    },
    created () {
        this.meno = this.company.ko_meno
        this.email = this.company.ko_email
        this.tel = this.company.ko_tel
    },
    methods: {
        sendData(){
            let data = {
                ko_meno: this.meno,
                ko_tel: this.tel,
                ko_email: this.email
            }
            this.$emit('data', data);
        },
        onlyNumber (event) {
            const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '+', ' '];
            if (!keysAllowed.includes(event.key) || this.tel.length > 15) {
                event.preventDefault()
            }
        },
    },
    watch: {
        meno: function(){
            this.sendData()
        },
        tel: function(){
            this.sendData()
        },  
        email: function(){
            this.sendData()
        },
    },
}
</script>

<style lang="scss" scoped>
.form-floating{
    width: 430px;
    height: 55px;
    margin: 0 auto;
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
    input{
        display: flex !important;
        align-items: center !important;
        background: #FFFFFF;
        border: 1px solid #DDE3E8;
        box-sizing: border-box;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        display: flex;
        align-items: center;
        color: #212541;
        padding-left: 23px;
    }
    label{
        display: flex !important;
        align-items: center !important;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598A7;
        padding-left: 23px;
    }
}
.info{
    position: absolute;
    height: 20px;
    top: 16px;
    right: 11px;
    .info_icon{
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;
        img{
            width: 80%;
            height: 80%;
        }
    }
    .my_tooltip{
        bottom: 22px;
        right: -7px;
    }
    &:hover{
        .my_tooltip{
            opacity: 1;
        }
    }
}
.agree_tooltip{
    position: relative;
}
.my_tooltip{
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #F3385A;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity .5s ease-in-out;
    &::after{
        content: '';
        width: 15px;
        height: 15px;
        background: #F3385A;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}
</style>